import { render, staticRenderFns } from "./funds-records.vue?vue&type=template&id=6ac967b9&scoped=true"
import script from "./funds-records.vue?vue&type=script&lang=js"
export * from "./funds-records.vue?vue&type=script&lang=js"
import style0 from "./funds-records.vue?vue&type=style&index=0&id=6ac967b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac967b9",
  null
  
)

export default component.exports